import i18n from '@/i18n';
import { LogLevel } from '@/lib/api';

/**
 * Get display text for status code
 */
export const getStatusText = (status: number): string => {
  switch (status) {
    case 0: return i18n.t('common:status.initial');
    case 5: return i18n.t('common:status.fetched');
    case 10: return i18n.t('common:status.ready');
    case 20: return i18n.t('common:status.playing');
    case 30: return i18n.t('common:status.ended');
    case 40: return i18n.t('common:status.completed');
    default: return i18n.t('common:status.unknown', { status });
  }
};

/**
 * Convert time to MM:SS format (simple version)
 */
export const formatTimeSimple = (dateString: string | undefined): string => {
  if (!dateString) return '-';

  const date = new Date(dateString);
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');

  return `${minutes}:${seconds}`;
};

/**
 * Convert time to MM:SS.3f format (with milliseconds)
 */
export const formatTimeWithMilliseconds = (dateString: string | undefined): string => {
  if (!dateString) return '-';

  const date = new Date(dateString);
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  const milliseconds = date.getMilliseconds().toString().padStart(3, '0');

  return `${minutes}:${seconds}.${milliseconds}`;
};

/**
 * Extract filename from file path
 */
export const extractFilenameFromPath = (path: string): string => {
  return path.split('/').pop() || path;
};

/**
 * Format the last part of UUID with MIME type for display
 */
export const formatUuidLastPartWithMimeType = (src: string, mimeType: string): string => {
  // Match UUID pattern in the URL
  const uuidMatch = src.match(/\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\//i);

  // Return last part of UUID with mimeType if found, otherwise return the original src
  if (uuidMatch && uuidMatch[1]) {
    // Get the last part of the UUID (after the last dash)
    const lastPart = uuidMatch[1].split('-').pop() || '';
    return `${lastPart} (${mimeType})`;
  }

  return src;
};

/**
 * Get Chip color based on log level
 */
export const getLogLevelColor = (level: LogLevel): 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' => {
  switch (level) {
    case LogLevel.DEBUG:
      return 'info';
    case LogLevel.INFO:
      return 'success';
    case LogLevel.WARN:
      return 'warning';
    case LogLevel.ERROR:
      return 'error';
    default:
      return 'default';
  }
};
